import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalSlice";
import auth from "./auth";

const store = configureStore({
  reducer: {
    global: globalReducer,
    auth: auth,
  },
  devTools: true,
});

export default store;
